import {z} from '@hono/zod-openapi';

import {ASSISTANT_TEMPLATE_SOURCE_MAX_CHARACTERS} from '../constants/ASSISTANT_TEMPLATE_SOURCE_MAX_CHARACTERS';

export const PendingTemplateEditProposalSchema = z
  .object({
    revisionId: z.string().uuid(),
    summary: z.string().min(1).max(500),
    source: z.string().min(1).max(ASSISTANT_TEMPLATE_SOURCE_MAX_CHARACTERS),
  })
  .openapi('PendingTemplateEditProposal');

export type PendingTemplateEditProposal = z.infer<typeof PendingTemplateEditProposalSchema>;
